// extracted by mini-css-extract-plugin
export default {"navbarItem":"NavbarItem_navbarItem__jtjYC","active":"NavbarItem_active__OQJKY"};